export default __webpack_public_path__ + "1b5de672ef45b337462d5be2a957968e.png";